
import { VenuesOrg } from '../VenuesOrg';

export class VenuesOrgSite extends VenuesOrg {

  constructor(props) {
    super(props, {pageForOrgType: 'SITE'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/sites/VenuesOrgSite.js